import { APP_ENV } from '@/config/env';
import { notFoundErrorMsg } from './error';
import { API_PREFIX } from '@/config/const';

const fetcher = async (url: string, token?: string) => {
  const headers: HeadersInit = {
    'Content-Type': 'application/json',
    'ngrok-skip-browser-warning': 'true',
  };

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const response = await fetch(`${APP_ENV.apiUrl}/${API_PREFIX}/${url}`, {
    method: 'GET',
    headers,
  });

  const contentType = response.headers.get('content-type');

  if (!contentType || !contentType.includes('application/json')) {
    throw new Error('Sorry, something went wrong.');
  }

  const data = response.status !== 204 ? await response.json() : null;

  if (!response.ok) {
    if (response.status === 404) throw new Error(notFoundErrorMsg);
    throw new Error(data?.message || 'Sorry, something went wrong.');
  }

  return data;
};

export default fetcher;
